export const subTypes = [
  {
    type: "marketplace",
    defaultValue: false,
    color: "#61adaf",
    label: "Marketplace",
  },
  {
    type: "eCommerce",
    defaultValue: false,
    color: "#957186",
    label: "E-commerce",
  },
  {
    type: "erpAndAccounting",
    defaultValue: false,
    color: "#888",
    label: "ERP and Accounting",
  },
];

export const countries = [
  {
    name: "canada",
    label: "Canada",
    defaultValue: false,
  },
  {
    name: "us",
    label: "United States",
    defaultValue: false,
  },
];

type T = keyof typeof countries;

export interface Partner {
  name: string;
  type: keyof typeof subTypes;
  desc: string;
  logoPath: string;
  url: string;
  isFeatured: boolean;
  countries: T[];
  isBlocked?: boolean;
  label: string;
  color: string;
}
